<template>
  <div id="movies-show" class="clearfix row-v2">
    <div class="col left">
      <div :class="{'movie col__box clearfix': true, 'movie--has-bg': movie.trailer_image}">
        <div class="movie__background" :style="{backgroundImage: `url(${movie.trailer_image})`}" v-show="movie.trailer_image"></div>
        <div class="movie__content">
          <div class="poster">
            <!-- /images/default.jpg -->
            <img :src="cropImage(movie.image, 240, 355) || ''" :alt="movie.name" class="box-line">
          </div>
          <movie-info-component :movie="movie" />
          <br>
          <br>
          <br>
          <template v-if="movie.episodes.length">
            <router-link :to="route('watch.show', movie.episodes[0].slug)" :title="$t('Watch now')" class="btn btn-primary">{{$t('Watch now')}}</router-link>
          </template>
          &nbsp;&nbsp;&nbsp;
          <a class="btn btn-primary" data-toggle="modal" title="Watch Trailer" href='#modal-id'><i class="fa fa-play-circle-o fa-lg"></i> Watch Trailer</a>
          <br>
          <br>
          <social-network-sharing-component :url="url" />
        </div>
      </div>
      <watch-trailer-component :url="movie.trailer" :movieName="movie.name" />
      <div class="col__box text-justify" v-if="movie.storyline">
        <strong>{{$t('Storyline')}}: </strong><span v-html="movie.storyline"></span>
      </div>
      <div class="col__box" v-if="movie.episodes.length > 1 || (movie.episodes.length == 1 && movie.episodes[0].index > 1)">
        <table class="table table-bordered table-episodes">
          <tbody>
            <tr v-for="(tr, index) in chunkedEpisodes" :key="index">
              <td v-for="episode in tr" class="text-center" :key="episode.slug">
                <template v-if="!Number.isInteger(episode)">
                  <router-link :to="route('watch.show', episode.slug)" :title="episode.name">{{episode.index || 'blank'}}</router-link>
                </template>
                <span class="transparent" v-else>{{episode}}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <table class="table table-hover">
          <tbody>
            <template v-for="episode in movie.episodes">
              <tr v-if="episode.index == null" :key="episode.slug">
                <td>
                  <router-link :to="route('watch.show', episode.slug)" :title="episode.name">{{episode.name}}</router-link>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <div class="col__box">
        <div class="box-line"></div>
        <div class="box-line"></div>
        <div class="box-line"></div>
        <div class="box-line"></div>
        <span class="box-line a1"></span>
        <!-- <comments-component :slug="movie.sug" /> -->
      </div>
    </div>
    <div class="col right">
      <div class="col__box">
        col right
      </div>
    </div>
  </div>
</template>
<script>
'use strict';
import Helper from '@/Helper';
export default {
  name: 'movie-show',
  components: {
     ...Helper.loadComponents([
      'social-network-sharing',
      'watch-trailer',
      'movie-info',
    ]),
  },
  data() {
    return {
      url: location.href,
      movie: {
        best_rating: '?',
        series: {},
        characters: [],
        description: '',
        episodes: [],
        countries: [],
        image: '',
        name: '',
        subname: '',
        trailer: '',
        trailer_image: '',
        athors: [],
      },
    };
  },
  methods: {
    load() {
      window.api.movies[this.$route.params.slug].get({
        with: 'episodes,countries,series,characters,athors,categories,keywords'
      }).then((movie) => {
        movie.best_rating = Number(movie.best_rating);
        this.$set(this, 'movie', movie);
        window.api.views[movie.id].update();
        this.setTitle(movie.name);
      }).catch(() => this.$router.push({ query: { page_not_found: true } }));
    }
  },
  created() {
    this.load();
  },
  computed: {
    chunkedEpisodes() {
      let trs = [];
      let tr = [];
      let index = 1;
      let items = [];
      this.movie.episodes.forEach((episode) => {
        if (episode.index === null) {
          return;
        }
        while (index < episode.index) {
          items.push(index++);
        }
        items.push(episode);
        index++;
      });
      items.forEach((item, index) => {
        tr.push(item);
        if (index % 10 === 9 || index + 1 === items.length) {
          trs.push(tr);
          tr = [];
        }
      });
      return trs;
    }
  }
}

</script>
